import { Button, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import SalamaImage from '../../assets/payment.png';

const Home = () => (
  <div className="flex flex-col items-center justify-center md:flex-row">
    {/* Right: Image */}
    <img
      src={SalamaImage}
      alt="Salama"
      // style={{ width: "auto", height: "auto", maxHeight: "300px" }} 
    />

    {/* Left: Text and Button */}
    <div className="text-center md:text-left md:w-1/2 p-4">
      <Typography variant="h2" className="font-bold mb-4">
        Welcome to Salama Pay!
      </Typography>
      <Typography className="mb-4">
        Make safe and secure financial transactions with ease.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        component={Link}
        to="/signup"
        size="small"
      >
        Get Started
      </Button>
    </div>
  </div>
);

export default Home;
